<template>
  <div class="lf marketing ml mtt">

    <div class="marketing-wrap">
      <div class="marketing-inner">
        <div id="myChartLine" style="width:100%;height:100%;"></div>
      </div>
      <!-- <div class="statistic-box row">
          <div class="statistic-item col-md-6" v-for="item in indexData" v-bind:key="item.name">
              <div class="icon-content">
                  <span class="iconfont icon-shuju"></span>
              </div>
              <div class="text-content">
                  <div class="text">
                      <span class="counter">
                          <ICountUp :delay="delay" :endVal="item.value" :options="options"
                              @ready="onReady" />
                      </span>
                  </div>
                  <div class="sub-title">{{item.name}}</div>
              </div>
          </div>
      </div> -->
    </div>
    <title-h3 :titlemsg="titlemsg"></title-h3>
  </div>

</template>

<script>
  import ICountUp from 'vue-countup-v2'
  import title from '../title';
  export default{
    name:'travelLine',
    data(){
      return{
        delay: 0,
        endVal: 120500,
        titlemsg:'订单统计',
        indexData: [{ name: '秒杀订单数量', value: 1341560 }, { name: '拼团订单数量', value: 31582 }, { name: '预售订单数量', value: 32320 }],
      }
    },
    mounted(){
      this.drawLine();
    },
    onReady(instance, CountUp){
      return
      const that = this
      instance.update(that.endVal + 100)
    },
    methods: {
      drawLine(){
        // 基于准备好的dom，初始化echarts实例
        let myChart = this.$echarts.init(document.getElementById('myChartLine'))
        // 绘制图表
        // 指定图表的配置项和数据
         var option = {
            tooltip : {
              trigger: 'axis'
            },
           grid:{
             left:'12%',
             top:'20%',
             bottom:'12%',
             right:'12%'
           },
            legend: {
              data:['秒杀','拼团','助力'],
              textStyle:{
                  color:'#fff'
              },
              top:'6%',
              left:'25%'
            },
            xAxis : [
              {
                type : 'category',
                axisLabel: {
                  textStyle: {
                    color: '#fff'
                  }
                },
                axisTick: {
                  show: false
                },
                axisLine: {
                  show: true,
                  lineStyle:{
                    color:'#637eaf'
                  }
                },
                data : ['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月']
              }
            ],
            yAxis : [
              {
                type : 'value',
                axisLabel: {
                  textStyle: {
                    color: '#fff'
                  }
                },
                axisTick: {  //轴上的刻度线
                  show: false
                },
                axisLine: {
                  show: true,
                  lineStyle:{
                    color:'#637eaf'
                  }
                },
              },
            ],
            series : [
              {
                name:'秒杀',
                type:'bar',
                data:[200, 400, 100, 1630, 250, 700, 1305, 592, 32, 1800, 60, 30],
                itemStyle: {
                  color:'#ba40ec'
                },
                markPoint : {
                  data : [
                    {type : 'max', name: '最大值'},
                    {type : 'min', name: '最小值'}
                  ]
                },
                markLine : {
                  data : [
                    {type : 'average', name: '平均值'}
                  ]
                }
              },

              {
                name:'拼团',
                type:'bar',
                itemStyle: {
                  color:'#f3a54f'
                },
                data:[205, 500, 900, 26, 28, 70, 175, 182, 48, 18, 6, 2],
                markPoint : {
                  data : [
                    {name : '年最高', value : 182.2, xAxis: 7, yAxis: 183},
                    {name : '年最低', value : 2.3, xAxis: 11, yAxis: 3}
                  ]
                },
                markLine : {
                  data : [
                    {type : 'average', name : '平均值'}
                  ]
                }
              },
              {
                name:'助力',
                type:'bar',
                itemStyle: {
                  color:'#61A0A8'
                },
                data:[188, 600, 200, 26, 18, 30, 105, 182, 48, 18, 6, 2],
                markPoint : {
                  data : [
                    {name : '年最高', value : 162.2, xAxis: 7, yAxis: 183},
                    {name : '年最低', value : 1.3, xAxis: 11, yAxis: 3}
                  ]
                },
                markLine : {
                  data : [
                    {type : 'average', name : '平均值'}
                  ]
                }
              }
            ]
          };

        // 使用刚指定的配置项和数据显示图表。
        myChart.setOption(option);
      }
    },
    components:{
      'title-h3':title,
      ICountUp
    }
  }

</script>

<style>
.statistic-box{
      display: flex;
      flex-wrap: wrap;
      width: 100%;
      margin-top: 0.05rem;
    }
    .statistic-item {
        display: flex;
        /* margin-bottom: 15px; */
        align-items: center;
        overflow: hidden;
        width: 33.3%;
        height: 0.7rem;
        color: #fff;
    }

    .statistic-item .icon-content {
        width: 0.45rem;
        min-width: 0.45rem;
        height: 0.45rem;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #3b4e82;
        border-radius: 50%;
    }
    .text-content .text{
      font-size: 0.3rem;
    }
    .text-content .sub-title{
        font-size: 0.16rem;
        color: #4e6bba;
    }
    .icon-content .iconfont {
        font-size: 24px;
        color: #fff;
    }

    .text-content {
        margin-left: 10px;
        overflow: hidden;
    }

</style>



// WEBPACK FOOTER //
// src/components/marketing/travelLine.vue